module.exports = __webpack_public_path__ + "static/media/dark-theme-max-speed.53ad9f3e.svg";